import { CentraCheckoutFinalize } from "@made-people/grease-centra";
import { useActionData } from "@remix-run/react";
import { SuccessPage } from "@made-people/blueprint-success-page";
import { action } from "./_index";
import { Button } from "@made-people/blueprint-button";
import { Heading } from "@made-people/blueprint-heading";
import { Checkout } from "@made-people/blueprint-checkout";
import { useTranslate } from "@made-people/grease-translations";
import { GenericOrderReceiptProps } from "@made-people/grease-order";

const SelectionNotFound = () => {
  const translate = useTranslate();
  return (
    <div className="h-[60vh] w-full flex flex-col justify-center items-center gap-4 lg:gap-6 px-6">
      <Heading
        heading={translate("Checkout_Cart_Not_Found")}
        variants={{
          headingSize: "xl",
        }}
      />
      <span className="text-center">
        {translate("Checkout_Cart_Not_Found_Text")}
      </span>
      <Button as="a" link={{ href: "" }} label={translate("Go_To_Home")} />
    </div>
  );
};

const GenericOrderReceipt = (props: GenericOrderReceiptProps) => {
  return <SuccessPage {...props} />;
};

export const CheckoutFinalizeRoute = () => {
  const actionData = useActionData<typeof action>();
  const translate = useTranslate();

  return (
    <div className="bg-[#E2DFD7]">
      <Checkout
        backLink={{
          link: { href: "" },
          label: translate("Checkout_BackLink"),
          icon: "←",
          variants: { style: "no-underline" },
        }}
        heading={{
          heading: translate("Checkout_Receipt_Heading"),
          headingTag: "h1",
          variants: { headingSize: "2xl" },
        }}
      >
        <CentraCheckoutFinalize
          postData={actionData?.paymentMethodFields}
          uiConfig={{
            components: {
              GenericOrderReceipt,
              SelectionNotFound,
            },
          }}
        />
      </Checkout>
    </div>
  );
};
